import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "icon", "badge", "color", "size", "loading", "disabled"];
import React from 'react';
import PT from 'prop-types';
import SpinnerIcon from '@scaleflex/icons/spinner';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import Badge from '../badge';
import { ButtonSize, ButtonColor } from '../../utils/types';
import { getIconSize } from './button.utils';
import Styled from './button.styles';
var Button = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      badge = _ref.badge,
      color = _ref.color,
      size = _ref.size,
      loading = _ref.loading,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Styled.Button, _extends({
    type: "button"
  }, rest, {
    disabled: loading || disabled,
    color: color,
    size: size,
    ref: ref
  }), icon && /*#__PURE__*/React.createElement(Styled.Icon, {
    $loading: loading
  }, typeof icon === 'function' ? loading ? /*#__PURE__*/React.createElement(SpinnerIcon, {
    size: getIconSize(size)
  }) : icon({
    size: getIconSize(size)
  }) : // eslint-disable-next-line unicorn/no-nested-ternary
  loading ? /*#__PURE__*/React.createElement(SpinnerIcon, {
    size: getIconSize(size)
  }) : icon), loading && !icon && /*#__PURE__*/React.createElement(Styled.Icon, {
    $loading: loading
  }, /*#__PURE__*/React.createElement(SpinnerIcon, {
    size: getIconSize(size)
  })), /*#__PURE__*/React.createElement(Styled.Label, null, children), badge && /*#__PURE__*/React.createElement(Styled.Badge, null, /*#__PURE__*/React.createElement(Badge, {
    inline: true,
    size: 14,
    fontSize: 10,
    padding: "0 1px",
    badgeContent: badge,
    color: color === ButtonColor.Primary ? 'white' : 'secondary'
  })));
});
Button.defaultProps = {
  size: ButtonSize.Md,
  color: ButtonColor.Secondary
};
Button.propTypes = {
  size: PT.oneOf(objectValues(ButtonSize)),
  color: PT.oneOf(objectValues(ButtonColor)),
  icon: PT.oneOfType([PT.node, PT.func]),
  badge: PT.node,
  loading: PT.bool,
  disabled: PT.bool
};
export default Button;